(function () {
  const poly = {
    selectedOptions: { // IE11: HTMLSelectElement.prototype.selectedOptions
      descriptor: {
        enumerable: true,
        get: function () {
          return [].prototype.filter.call(this.options, function (option) {
            return option.selected;
          });
        }
      },
      target: HTMLSelectElement.prototype
    }
  };

  Object.keys(poly).forEach(function (key) {
    const { descriptor, target } = poly[key];

    if (!(key in target)) {
      Object.defineProperty(target, key, descriptor);
    }
  });
})();

(function EventPolyfill(window) { // IE11 does not have Event() contructor
  function Event(type, eventInit = {}) {
    const event = window.document.createEvent('Event');

    event.initEvent(type, !!eventInit.bubbles, !!eventInit.cancelable);

    return event;
  }

  if (typeof window.Event !== "function") {
    Object.setPrototypeOf(Event.prototype, window.Event);
    Event.prototype.constructor = Event;
    window.Event = Event;
  }
})(window);



// WEBPACK FOOTER //
// ./core/homegrown.js